import * as React from "react";
const SvgRemove24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "black",
        viewBox: "0 0 22 22"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M9 4a2 2 0 1 1 4 0H9ZM7 4a4 4 0 1 1 8 0h7v2H0V4h7ZM3 21V7h2v13h12V7h2v15H3v-1ZM7.5 8v10h2V8h-2Zm5 10V8h2v10h-2Z",
      clipRule: "evenodd"
    })
  );
export default SvgRemove24Px;
